import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  status: "scout" | "premiumScout" | "newContent" | "publishingEndUpClose";
};

const STATUS_AND_TEXT = {
  scout: "スカウト",
  premiumScout: "プレミアムスカウト",
  newContent: "NEW",
  publishingEndUpClose: "掲載終了間近",
};

export const WorkStatusLabel: FC<Props> = ({ status }) => (
  <span className={styles.label({ status })}>{STATUS_AND_TEXT[status]}</span>
);
